import RatioIcon1 from '../../assets/svg/1-1.svg?react';
import RatioIcon6 from '../../assets/svg/9-16.svg?react';
import RatioIcon7 from '../../assets/svg/16-9.svg?react';

const FJAIVideoGeneratorData = {
    RATIO_LIST: [
        {
            name: '16:9',
            value: 16 / 9,
            icon: RatioIcon7,
        },
        {
            name: '9:16',
            value: 9 / 16,
            icon: RatioIcon6,
        },
        {
            name: '1:1',
            value: 1,
            icon: RatioIcon1,
        },
    ],
    DURATION_LIST: [
        {
            name: '5s',
            value: 5,
        },
        {
            name: '10s',
            value: 10,
        },
    ],
    QUALITY_LISL: [
        {
            name: 'standard',
            value: 1,
        },
        {
            name: 'professional',
            value: 2,
        },
    ],
    MENU_LIST: [
        {
            text: 'text-to-video',
        },
        {
            text: 'image-to-video',
        },
    ],
    PROMPT_TEXT_LIMIT: 2000,
    PROMPT_PLACEHOLDER: '',
};

export default FJAIVideoGeneratorData;
